import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0D3B66", // Neon
      light: "#1F4F82", // Derived (lighter Neon)
      dark: "#082944", // Derived (darker Neon)
      contrastText: "#FAF0CA",
    },
    secondary: {
      main: "#F4D35E", // Bliss
      light: "#F7E58C", // Derived Bliss
      dark: "#E6BF3C", // Derived Bliss
      contrastText: "#0D3B66",
    },
    // background: {
    //   default: "#FAF0CA", // Sunshine
    //   paper: "#FFF7DE", // Sunshine (lighter)
    // },
    text: {
      primary: "#0D3B66",
      secondary: "#1F4F82",
      disabled: "#6B8BAA",
    },
    divider: "rgba(13,59,102,0.12)",
  },

  typography: {
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    // fontFamily: '"Playwrite NZ Basic", cursive',

    h1: {
      fontWeight: 700,
      fontSize: "2.4rem",
      letterSpacing: "-0.02em",
      color: "#0D3B66",
    },
    h2: {
      fontWeight: 600,
      fontSize: "1.8rem",
      letterSpacing: "-0.015em",
      color: "#0D3B66",
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.4rem",
      color: "#0D3B66",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.65,
      color: "#1F4F82",
    },
    body2: {
      fontSize: "0.95rem",
      color: "#4A6F95",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.02em",
    },
  },

  shape: {
    borderRadius: 14,
  },

  components: {
    /* =========================
       BUTTONS (PREMIUM FEEL)
       ========================= */
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 14,
          padding: "10px 20px",
          transition: "all 0.25s ease",
        },
        containedPrimary: {
          backgroundColor: "#0D3B66",
          color: "#FAF0CA",
          boxShadow: "0 6px 18px rgba(13,59,102,0.18)",
          "&:hover": {
            backgroundColor: "#082944",
            boxShadow: "0 10px 24px rgba(13,59,102,0.28)",
          },
        },
        containedSecondary: {
          backgroundColor: "#F4D35E",
          color: "#0D3B66",
          boxShadow: "0 6px 18px rgba(244,211,94,0.35)",
          "&:hover": {
            backgroundColor: "#E6BF3C",
          },
        },
        outlined: {
          borderColor: "rgba(13,59,102,0.4)",
          color: "#0D3B66",
          "&:hover": {
            borderColor: "#0D3B66",
            backgroundColor: "rgba(13,59,102,0.05)",
          },
        },
      },
    },

    /* =========================
       CARDS / PAPER
       ========================= */
    // MuiPaper: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: 18,
    //       backgroundImage: "none",
    //     },
    //     elevation1: {
    //       boxShadow: "0 6px 20px rgba(13,59,102,0.08)",
    //     },
    //     elevation3: {
    //       boxShadow: "0 12px 32px rgba(13,59,102,0.12)",
    //     },
    //   },
    // },

    /* =========================
       INPUTS (CLEAN & CALM)
       ========================= */
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          // backgroundColor: "#FFF7DE",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0D3B66",
            borderWidth: 2,
          },
        },
      },
    },

    /* =========================
       LINKS
       ========================= */
    MuiLink: {
      styleOverrides: {
        root: {
          color: "#0D3B66",
          fontWeight: 500,
          "&:hover": {
            color: "#F4D35E",
          },
        },
      },
    },
  },
});

export default theme;
